import { useMemo } from "react";

// Lightweight CSS-based ember particles + moving grid backdrop
export default function ParticleField() {
  const embers = useMemo(
    () =>
      Array.from({ length: 28 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        duration: 10 + Math.random() * 14,
        delay: Math.random() * 12,
        size: 2 + Math.random() * 4,
        drift: `${(Math.random() - 0.5) * 200}px`,
        opacity: 0.4 + Math.random() * 0.5,
      })),
    []
  );

  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0">
      {/* Radial vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,140,0,0.10),transparent_55%)]" />
      {/* Grid */}
      <div className="absolute inset-0 grid-bg opacity-70" />
      {/* Bottom glow */}
      <div className="absolute inset-x-0 bottom-0 h-64 bg-[radial-gradient(ellipse_at_bottom,rgba(255,191,0,0.12),transparent_70%)]" />
      {/* Embers */}
      <div className="absolute inset-0 overflow-hidden">
        {embers.map((e) => (
          <span
            key={e.id}
            className="ember"
            style={{
              left: `${e.left}%`,
              width: e.size,
              height: e.size,
              animationDuration: `${e.duration}s`,
              animationDelay: `${e.delay}s`,
              opacity: e.opacity,
              // custom property for drift
              // eslint-disable-next-line
              ["--drift"]: e.drift,
            }}
          />
        ))}
      </div>
    </div>
  );
}
